import vlpqMarketingUtility from '@sparta.auto-loans.utilities/prequal-marketing-code-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import { secureLink } from '@sparta.global.helpers/secure-link-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n<div class=\"prequal-engagement-container\">\n\n  <div class=\"row small-collapse\">\n    <div class=\"column\">\n      "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"banner") : stack1),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":8,"column":6},"end":{"line":8,"column":32}}}))
    + "\n    </div>\n  </div>\n\n  <div class=\"row\">\n    <div class=\"column small-centered small-12 medium-8\">\n      <div class=\"prequal-engagement-research-card\">\n        <h2 class=\"headline-large cnx-light prequal-engagement-research-card-heading\">\n          "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"engagementCard") : stack1)) != null ? lookupProperty(stack1,"heading") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </h2>\n        "
    + container.escapeExpression((lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"engagementCard") : stack1)) != null ? lookupProperty(stack1,"getPrequalifiedLink") : stack1),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":18,"column":8},"end":{"line":18,"column":87}}}))
    + "\n        <p class=\"prequal-body-large roboto-regular prequal-engagement-research-card-disclaimer\">\n          "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? lookupProperty(stack1,"engagementCard") : stack1)) != null ? lookupProperty(stack1,"scoreImpact") : stack1), depth0)) != null ? stack1 : "")
    + "\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/prequal-auto-engagement-module",
  "version": "1.0.5",
  "id": "prequal-auto-engagement-module",
  "containerID": "autoLoansPrequalAutoEngagementModule",
  "moduleName": "auto-loans-prequal-auto-engagement-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "prequal-auto-engagement-module",
  "data": {
    "content": "{{json content}}",
    "init": "AutoLoansPrequalAutoEngagementModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        secureLink,
        picture
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    secureLink,
    picture
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.auto-loans.utilities/prequal-marketing-code-utility": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.helpers/secure-link-helper": "^1.0.0"
  },
  "stores": []
};

/**
 * @class PrequalAutoEngagementModule
 * @extends {Module}
 */
class PrequalAutoEngagementModule extends Module {
  /**
   * Creates an instance of PrequalAutoEngagementModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Inits marketing code utility
   * @returns {void}
   */
  init() {
    vlpqMarketingUtility.init();
  }
}
registerModuleClass({
  moduleClass: PrequalAutoEngagementModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { PrequalAutoEngagementModule as default, moduleConfig };
